import { Component } from '@angular/core';

@Component({
  selector: 'app-let-loading-indicator',
  imports: [],
  templateUrl: './let-loading-indicator.component.html',
  styleUrl: './let-loading-indicator.component.css',
})
export class LetLoadingIndicatorComponent {}
